import data from "@/data/case-slugs.json";

const byId = (data && data.byId) || {};

export function recordBySlug(slug) {
  const id = Object.keys(byId).find((key) => byId[key] && byId[key].slug === slug);
  if (!id) return null;
  return Object.assign({ id }, byId[id]);
}

export function caseUrlById(id) {
  const rec = byId[String(id)];
  return rec && rec.slug ? `/case/${rec.slug}` : "";
}
